import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const baseUrl =
  process.env.REACT_APP_BACKEND_BASE_URL || "http://localhost:5000";

/* =========================
   THUNK
========================= */
export const sendBusinessForgotPasswordRequest = createAsyncThunk(
  "businessForgotPassword/send",
  async ({ email }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${baseUrl}/business/user/forgot-password`,
        { email }
      );

      return {
        message: response.data?.message,
        success: true,
        expiresAt: response.data?.expiresAt,
      };
    } catch (error) {
      return rejectWithValue({
        message:
          error.response?.data?.message ||
          error.message ||
          "Something went wrong",
      });
    }
  }
);

/* =========================
   SLICE
========================= */
const businessForgotPasswordSlice = createSlice({
  name: "businessForgotPassword",
  initialState: {
    loading: false,
    message: "",
    error: null,
    success: false,
    expiresAt: null,
  },

  reducers: {
    clearBusinessForgotState: (state) => {
      state.loading = false;
      state.message = "";
      state.error = null;
      state.success = false;
      state.expiresAt = null;
    },
  },

  extraReducers: (builder) => {
    builder

      /* ================= PENDING ================= */
      .addCase(sendBusinessForgotPasswordRequest.pending, (state) => {
        state.loading = true;
        state.message = "";
        state.error = null;
        state.success = false;
      })

      /* ================= SUCCESS ================= */
      .addCase(
        sendBusinessForgotPasswordRequest.fulfilled,
        (state, action) => {
          state.loading = false;
          state.message = action.payload?.message;
          state.success = action.payload?.success;
          state.expiresAt = action.payload?.expiresAt;
        }
      )

      /* ================= ERROR ================= */
      .addCase(
        sendBusinessForgotPasswordRequest.rejected,
        (state, action) => {
          state.loading = false;
          state.error = action.payload?.message || "Request failed";
        }
      );
  },
});

export const { clearBusinessForgotState } =
  businessForgotPasswordSlice.actions;

export default businessForgotPasswordSlice.reducer;
